/**
 * Highlights only the top-level menu the visitor actually navigated through.
 *
 * A collection can live under several menus (e.g. "Pregnancy" under Skin Types,
 * Shop By Concern and Shop By Life Stage). Shopify's `link.child_active` is
 * derived purely from the current URL, so server-side it underlines EVERY menu
 * that contains the active page. We strip that server-side parent highlight in
 * the Liquid (header-dropdown-menu / header-drawer) and instead remember which
 * menu the visitor clicked through, then re-apply the active style to just that
 * one on the destination page.
 *
 * State is keyed by destination path in sessionStorage, so it survives a reload
 * but is scoped to the tab. Reaching a collection without clicking a menu
 * (direct link, refresh from elsewhere) intentionally leaves no parent active.
 */
(function () {
  var STORE_PREFIX = 'hg-nav-source:';

  function pathOf(href) {
    try {
      return new URL(href, window.location.origin).pathname;
    } catch (e) {
      return null;
    }
  }

  // Compare paths ignoring a trailing slash (/collections/x === /collections/x/).
  function normalize(path) {
    if (!path) return path;
    return path.length > 1 ? path.replace(/\/$/, '') : path;
  }

  // Record which top-level menu a nav click came from, keyed by where it goes.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[data-nav-source]');
    if (!link) return;
    var path = pathOf(link.href);
    if (!path) return;
    try {
      sessionStorage.setItem(STORE_PREFIX + normalize(path), link.dataset.navSource);
    } catch (e) {
      /* sessionStorage unavailable (private mode / disabled) — skip silently. */
    }
  });

  // On the destination page, underline only the menu that was clicked.
  function highlightActiveParent() {
    var handle;
    try {
      handle = sessionStorage.getItem(STORE_PREFIX + normalize(window.location.pathname));
    } catch (e) {
      return;
    }
    if (!handle) return;

    var safeHandle = handle.replace(/"/g, '\\"');

    // Underline the parent menu the visitor clicked through.
    document.querySelectorAll('[data-nav-parent="' + safeHandle + '"]').forEach(function (parent) {
      if (parent.closest('.menu-drawer')) {
        parent.classList.add('menu-drawer__menu-item--active');
      } else {
        var label = parent.querySelector(':scope > span') || parent;
        label.classList.add('header__active-menu-item');
      }
    });

    // Underline the current collection's link, but only inside that same menu.
    var here = normalize(window.location.pathname);
    document.querySelectorAll('a[data-nav-source="' + safeHandle + '"]').forEach(function (link) {
      if (normalize(pathOf(link.href)) !== here) return;
      if (link.closest('.menu-drawer')) {
        link.classList.add('menu-drawer__menu-item--active');
      } else {
        link.classList.add('list-menu__item--active');
      }
      link.setAttribute('aria-current', 'page');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', highlightActiveParent);
  } else {
    highlightActiveParent();
  }
})();
